<script setup>
const name = "Separator";
</script>
<template>
  <div class="row">
    <div class="col">
      <hr/>
    </div>
  </div>
</template>
